import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                next: 'next',
                prev: 'prev'
            }
        }
    }

    init() {

    }

    next() {
        this.call('next', 'NavCases');
    }

    prev() {
        this.call('prev', 'NavCases');
    }
}
